<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import { listOf, payloadOf, textOf } from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const section = computed(() => {
  const payload = payloadOf(props.event);
  const empty = t('POST_SALE.COMMON.EMPTY_VALUE');
  const sellers =
    payload.averbacao ||
    (payload.vendedores_averb || []).map(nome => ({ nome }));

  return {
    title: t('POST_SALE.STATUS_DETAILS.ANNOTATION_SELLERS'),
    badge:
      sellers.length === 1
        ? t('POST_SALE.STATUS_DETAILS.ONE_SELLER')
        : t('POST_SALE.STATUS_DETAILS.SELLER_COUNT', {
            count: sellers.length,
          }),
    items: sellers.length
      ? sellers.map((seller, index) => ({
          label: textOf(
            seller.nome ||
              seller.name ||
              t('POST_SALE.STATUS_DETAILS.SELLER_NUMBER', {
                number: index + 1,
              }),
            empty,
            t
          ),
          value: listOf(seller.tipo_averbacao, empty, t),
        }))
      : [
          {
            label: t('POST_SALE.STATUS_DETAILS.SELLERS'),
            value: textOf(payload.quant_vendedores_averb, empty, t),
          },
        ],
  };
});
</script>

<template>
  <PostSaleStatusDetailSection v-bind="section" />
</template>
